import { render } from "./sing_list.vue?vue&type=template&id=186fbbe7"
import script from "./sing_list.vue?vue&type=script&lang=js"
export * from "./sing_list.vue?vue&type=script&lang=js"

import "./sing_list.vue?vue&type=style&index=0&id=186fbbe7&lang=css"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__